export default {
  // Review-related translations
  "edit_review": "Edit Review",
  "review": "Review",
  "film_friendly_score": "Film-Friendly Score",
  "hand_check": "Hand Check",
  "successful": "Successful",
  "unsuccessful": "Unsuccessful",
  "delete_review": "Delete Review",
  "review_by": "Review by",
  "Terminal": "Terminal",
};
